import React, { useCallback, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiSearch, FiUser } from 'react-icons/fi';
import api from '../services/api';
import Klanten360Modal from '../components/klanten/Klanten360Modal';
import KlantenWeekAudienceTable from '../components/klanten/KlantenWeekAudienceTable';
import { useKlanten360Modal } from '../hooks/useKlanten360Modal';
import { useKlantenWeekAudience } from '../hooks/useKlantenWeekAudience';
import '../components/Button.css';
import './Klanten360.css';

export default function Klanten360() {
  const [searchParams] = useSearchParams();
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const week = useKlantenWeekAudience(7, true);
  const {
    open360,
    closeModal,
    modalEmail,
    modalProfile,
    modalLoading,
    modalError,
    unlinkVisitor,
    unlinkBusyId,
  } = useKlanten360Modal();

  const search = useCallback(async () => {
    const term = q.trim();
    if (term.length < 2) return;
    setError('');
    setLoading(true);
    setResults([]);
    try {
      if (term.includes('@')) {
        await open360(term);
      } else {
        const res = await api.get('/customers/search', { params: { q: term } });
        setResults(res.data?.results || []);
      }
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  }, [q, open360]);

  useEffect(() => {
    const email = searchParams.get('email');
    if (!email || !email.includes('@')) return;
    setQ(email);
    open360(email.trim());
  }, [searchParams, open360]);

  return (
    <div className="klanten360-page">
      <h1>
        <FiUser aria-hidden /> Klanten 360°
      </h1>
      <p className="muted klanten360-intro">
        Orders, browse-historie, pop-up inschrijving en laatste winkelwagen-snapshot. Zelfde weeklijst als Marketing →
        Pop-up. Vanuit <Link to="/attributie">Attributie</Link> kun je straks direct doorklikken op e-mail/naam.
      </p>

      <KlantenWeekAudienceTable
        data={week.data}
        loading={week.loading}
        error={week.error}
        onRefresh={week.reload}
        onOpen360={open360}
      />

      <div className="klanten360-search">
        <input
          className="form-input"
          type="search"
          placeholder="E-mail of deel van adres…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && search()}
        />
        <button type="button" className="btn btn-primary" disabled={loading} onClick={search}>
          <FiSearch /> Zoeken
        </button>
      </div>

      {error ? <p className="marketing-ig-error">{error}</p> : null}
      {loading ? <p className="muted">Laden…</p> : null}

      {results.length > 0 && (
        <ul className="klanten360-results">
          {results.map((r) => (
            <li key={r.email}>
              <button type="button" className="klanten360-result-btn" onClick={() => open360(r.email)}>
                <strong>{r.email}</strong>
                {r.klant_naam ? <span className="muted"> — {r.klant_naam}</span> : null}
                {r.order_count > 0 ? <span className="muted"> · {r.order_count} order(s)</span> : null}
              </button>
            </li>
          ))}
        </ul>
      )}

      <Klanten360Modal
        open={!!modalEmail}
        email={modalEmail}
        profile={modalProfile}
        loading={modalLoading}
        error={modalError}
        onClose={closeModal}
        onUnlinkVisitor={unlinkVisitor}
        unlinkBusyId={unlinkBusyId}
      />
    </div>
  );
}
